import lodashCloneDeep from 'lodash/cloneDeep';
import lodashIsEqual from 'lodash/isEqual';
import { allowedSignalKinds } from '../../constants/allowedSignalKinds';
import { checkMatch } from '../general/checkMatch';
import { getAtomTypeFromNucleus } from '../general/getAtomTypeFromNucleus';
import { isEditedHSQC } from '../general/isEditedHSQC';
/**
 * Get all different 2D signals from experiments with allowed signal kinds in "signalKindsToInclude".
 *
 * @param {ExperimentsType} experiments1D
 */
export function getSignals2D(experiments2D) {
    // store valid signals from 2D experiments
    const _signals2D = {};
    Object.keys(experiments2D).forEach((experimentType) => {
        const _signals = [];
        // for now we use the first occurring spectrum only, for each experiment type (current loop) and nuclei combination
        const indices = [];
        const nuclei = [];
        experiments2D[experimentType].forEach((_experiment, i) => {
            const experiment = _experiment;
            if (!nuclei.some((_nuclei) => lodashIsEqual(_nuclei, experiment.info.nucleus))) {
                nuclei.push(experiment.info.nucleus);
                indices.push(i);
            }
        });
        indices.forEach((index) => {
            const spectrum2D = experiments2D[experimentType][index];
            const atomType = spectrum2D.info.nucleus.map((nucleus) => getAtomTypeFromNucleus(nucleus));
            const __signals = spectrum2D.zones.values
                .map((zone) => zone.signals.filter((signal) => signal.kind && allowedSignalKinds.includes(signal.kind)))
                .flat();
            __signals.forEach((signal) => {
                if (!_signals.some((_signal) => checkMatch(_signal.signal.x.delta, signal.x.delta, 0.0) &&
                    checkMatch(_signal.signal.y.delta, signal.y.delta, 0.0))) {
                    _signals.push({
                        experimentType,
                        experimentID: spectrum2D.id,
                        atomType,
                        // @TODO here we assume that only one peak exists for the signal and its intensity indicates the sign
                        signal: {
                            ...lodashCloneDeep(signal),
                            sign: isEditedHSQC(spectrum2D) && signal.peaks
                                ? signal.peaks[0].z >= 0
                                    ? 1
                                    : -1
                                : 0,
                        },
                    });
                }
            });
        });
        _signals2D[experimentType] = _signals;
    });
    return _signals2D;
}
//# sourceMappingURL=getSignals2D.js.map